import { Button, CircularProgress } from '@material-ui/core'
import React from 'react'

const LoadingButton = ({ children = 'Submit', color = 'primary', loading, onClick, textOnly = false, variant = 'contained' }) => {
  const mounted = React.useRef(true)
  const [ internalLoading, setInternalLoading ] = React.useState(false)

  React.useEffect(() => {
    return () => {
      mounted.current = false
    }
  }, [])

  const handleClick = async () => {
    setInternalLoading(true)
    await onClick()
    if (mounted?.current) setInternalLoading(false)
  }

  const loadingValue = typeof loading === 'undefined' ? internalLoading : loading

  return (
    <div css={`position: relative;`}>
      <Button
        disabled={loadingValue}
        disableElevation
        {...(textOnly ? {} : { variant })}
        type='button'
        color={color}
        css={`
          ${loadingValue ? `
            opacity: 0.5;
            cursor: wait;
          ` : ''}
        `}
        onClick={handleClick}
      >
        {children}
      </Button>
      {loadingValue &&
        <CircularProgress
          size={24}
          css={`position: absolute; top: 50%; left: 50%; margin-left: -12px; margin-top: -12px;`}
          color='secondary' />
      }
    </div>
  )
}

export default LoadingButton
